import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async getParametreByNom(nom) {
    return (
      await axios.get(process.env.VUE_APP_URL_PARAMETRES + "Maintenance" + nom)
    ).data;
  },

  async getByNomStartingWithMaintenance() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PARAMETRES +
          "MaintenanceAll"
      )
    ).data;
  },
  async update(parametre) {
    return (
      await axios.put(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PARAMETRES +
          "Maintenance",
        parametre
      )
    ).data;
  },
  async getWprhLiquidation() {
    return (
      await axios.get(
        process.env.VUE_APP_BACKEND_API_URL +
          process.env.VUE_APP_URL_PARAMETRES +
          "WprhLiquidation"
      )
    ).data;
  },
};
